import gold from "./gold.svg";
import platinum from "./platinum.svg";
import diamond from "./diamond.svg";
import ruby from "./ruby.svg";
import emerald from "./emerald.svg";
import sapphire from "./sapphire.svg";
import pearl from "./pearl.svg";
import star from "./star.svg";
import starGold from "./star_gold.svg";
import starPlatinum from "./star_paltinum.svg";
import starEmerald from "./star_emerald.svg";
import starRuby from "./star_ruby.svg";
import starSapphire from "./star_sapphire.svg";
import starPearl from "./star_pearl.svg";
import opener from "./opener.svg";
import runner from "./runner.svg";
import winner from "./winner.svg";
import eagle from "./eagle.svg";

const pinIcons = {
  gold,
  platinum,
  diamond,
  ruby,
  emerald,
  sapphire,
  pearl,
  star,
  starGold,
  starEmerald,
  starRuby,
  starSapphire,
  starPearl,
  opener,
  runner,
  winner,
  eagle,
  starPlatinum,
};

export default pinIcons;
